import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TagColor {
    bgColor: string;
    textColor: string;
    iconColor: string;
}

interface InitialStateType {
    [tagName: string]: TagColor | null | undefined;
}
const initialState: InitialStateType = {};

const tagColorsSlice = createSlice({
    name: 'tagColors',
    initialState,
    reducers: {
        assignTagColor: (
            state,
            action: PayloadAction<{ tagName: string; bgColor: string; textColor: string; iconColor: string }>
        ) => {
            const { tagName, bgColor, textColor, iconColor } = action.payload;
            state[tagName] = { bgColor, textColor, iconColor };
        },

        removeTagColor: (state, action: PayloadAction<{ tagName: string }>) => {
            const { tagName } = action.payload;
            delete state[tagName];
        },
    },
});

export const { assignTagColor, removeTagColor } = tagColorsSlice.actions;
export default tagColorsSlice.reducer;
